module.exports = __webpack_public_path__ + "img/product-1-thumb-7.f87f55de.jpg";